module.exports = __webpack_public_path__ + "img/icon-login-error.1033d7a3.svg";